import React from 'react';
import { MY_ACCOUNT_OPTIONS } from '../propTypes/myAccountOptions';

const MyAccountScreenContext = React.createContext({
  selectedOption: MY_ACCOUNT_OPTIONS.PROFILE,
});

export default MyAccountScreenContext;
